<mat-card class="transparent">
    <mat-card-header class="stretch">

            <mat-card-title>
                <ng-content select="[title]"></ng-content>   
            </mat-card-title>
        
            <mat-card-subtitle>
                <ng-content select="[subTitle]"></ng-content>      
            </mat-card-subtitle>

    </mat-card-header>
    <mat-card-content>
        <div class="flex column stretch align">

            <mat-form-field appearance="outline" [formGroup]="form" class="stretch" >
                <mat-label>{{workspaceType}} Display Name</mat-label>
                <input matInput formControlName="businessNameRow" />
                <mat-error *ngIf="form.controls['businessNameRow'].hasError('required')"> 
                    Required
                </mat-error>
                <mat-error *ngIf="form.controls['businessNameRow'].hasError('pattern')"> 
                    No special characters
                </mat-error>
               
            </mat-form-field>

        </div>
        <mat-card-actions>
            <div class="flex" [ngClass]="canCancel ? 'between' : 'end'">

                <button mat-raised-button *ngIf="canCancel"  class="blueOutlineButton" mat-dialog-close>Cancel</button>
                <button mat-button (click)="submit()" [disabled]="form.invalid" class="blueButton" 
                    cdkFocusInitial>Create</button>
            </div>
        </mat-card-actions>
    </mat-card-content>
</mat-card>